// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__26K6S","col":"styles_col__23HI-","actions":"styles_actions__2czXG","conflict":"styles_conflict__KbK4r"};